module.exports = __webpack_public_path__ + "static/img/image_home_02.4046a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_home_02.png
// module id = NMh9
// module chunks = 10